import { create } from 'zustand';
import apiClient from '../utils/apiClient';

export const useCompaniesStore = create((set, get) => ({
  companies: [],
  isLoading: false,
  error: null,
  lastFetched: 0,
  cacheDuration: 5 * 60 * 1000,

  fetchCompanies: async (force = false) => {
    const now = Date.now();
    const { lastFetched, cacheDuration } = get();
    if (!force && now - lastFetched < cacheDuration) {
      return;
    }
    set({ isLoading: true, error: null });
    try {
      const response = await apiClient.get('/company-list');
      set({
        companies: Array.isArray(response) ? response : [],
        isLoading: false,
        lastFetched: now,
        error: null,
      });
    } catch (err) {
      set({ companies: [], isLoading: false, error: err.message || 'Failed to fetch companies' });
    }
  },

  getCompanyById: (id) => {
    const { companies } = get();
    return companies.find((c) => c.id === id) || null;
  },

  clearCompanies: () => {
    set({ companies: [], lastFetched: 0, error: null });
  },

  addCompany: async (company) => {
    const created = await apiClient.post('/company', company);
    set((state) => ({ companies: [...state.companies, created] }));
    return created;
  },

  updateCompany: async (id, company) => {
    const updated = await apiClient.put(`/company/${id}`, company);
    set((state) => ({
      companies: state.companies.map((c) => (c.id === id ? updated : c)),
    }));
    return updated;
  },

  deleteCompany: async (id) => {
    await apiClient.delete(`/company/${id}`);
    set((state) => ({ companies: state.companies.filter((c) => c.id !== id) }));
  },
}));
